import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import LandingPage from "@/pages/LandingPage";
import HowItWorksArticle from "@/pages/HowItWorksArticle";
import InstagramPost from "@/pages/InstagramPost";
import BrandKit from "@/pages/BrandKit";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ElderCarePage from "@/pages/ElderCarePage";
import LoginPage from "@/pages/LoginPage";
import OnboardingPage from "@/pages/OnboardingPage";
import MainApp from "@/pages/MainApp";
import DirectLogin from "@/pages/DirectLogin";
import WaitlistAdmin from "@/pages/WaitlistAdmin";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/how-it-works" element={<HowItWorksArticle />} />
        <Route path="/ig-post" element={<InstagramPost />} />
        <Route path="/brand-kit" element={<BrandKit />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/eldercare" element={<ElderCarePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/aavyaa" element={<DirectLogin />} />
        <Route path="/waitlist-admin" element={<WaitlistAdmin />} />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <MainApp />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <AppProvider>
      <AppRoutes />
      <Toaster position="top-center" richColors />
    </AppProvider>
  );
}

export default App;
